import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./styles/Navbar.css";
import { scrollToTop } from "./util"; // Importing the CSS for the Navbar

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [lastScrollY, setLastScrollY] = useState(0);
    const [isNavbarVisible, setIsNavbarVisible] = useState(true);
    const [isSpeakersOpen, setIsSpeakersOpen] = useState(false);

    // Handle Scroll Behavior (Hide/Show Navbar)
    const handleScroll = () => {
        if (typeof window !== "undefined") {
            if (window.scrollY > lastScrollY) {
                setIsNavbarVisible(false); // Scroll Down
                setIsSpeakersOpen(false);
                setIsOpen(false);
            } else {
                setIsNavbarVisible(true); // Scroll Up
            }
            setLastScrollY(window.scrollY);
        }
    };

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [lastScrollY]);

    // Toggle Hamburger Menu
    const toggleMenu = () => {
        if (isOpen) {
            scrollToTop();
        }
        setIsOpen(!isOpen);
        setIsSpeakersOpen(false);
    };

    // Toggle Speakers Dropdown
    // Toggle Speakers Dropdown
    const toggleSpeakersDropdown = () => {
        setIsSpeakersOpen(!isSpeakersOpen);
    };

    return (
        <nav className={`navbar ${isNavbarVisible ? "show" : "hide"}`}>
            <div className="navbar-container">
                <div className="logo">
                    <img
                        style={{ height: "30px", marginRight: "1rem" }}
                        src="/assets/cropped-FTGlogoNoText.jpg"
                    />
                    5th Tradition Group
                </div>
                <div className={`nav-links ${isOpen ? "active" : ""}`}>
                    <Link
                        to="/"
                        onClick={() => {
                            toggleMenu();
                            scrollToTop();
                        }}
                    >
                        Home
                    </Link>
                    <Link
                        to="/about"
                        onClick={() => {
                            toggleMenu();
                            scrollToTop();
                        }}
                    >
                        About
                    </Link>
                    <Link
                        to="/events"
                        onClick={() => {
                            toggleMenu();
                            scrollToTop();
                        }}
                    >
                        Events
                    </Link>
                    {/* Speakers with Collapsible Menu */}
                    <div className="nav-item">
                        {/* @ts-ignore */}
                        <Link
                            className="nav-link dropdown-btn"
                            onClick={toggleSpeakersDropdown}
                        >
                            Speakers
                        </Link>
                        {isSpeakersOpen && (
                            <div className="dropdown-content">
                                <Link
                                    to="/speakers"
                                    onClick={() => {
                                        toggleMenu();
                                        scrollToTop();
                                    }}
                                >
                                    Recent
                                </Link>
                                <Link
                                    to="/workshop"
                                    onClick={() => {
                                        toggleMenu();
                                        scrollToTop();
                                    }}
                                >
                                    Workshop
                                </Link>
                                <Link
                                    to="/archived"
                                    onClick={() => {
                                        toggleMenu();
                                        scrollToTop();
                                    }}
                                >
                                    Archived
                                </Link>
                                <Link
                                    to="/search"
                                    onClick={() => {
                                        toggleMenu();
                                        scrollToTop();
                                    }}
                                >
                                    Search Speakers
                                </Link>
                            </div>
                        )}
                    </div>
                    <Link
                        to="/contact"
                        onClick={() => {
                            toggleMenu();
                            scrollToTop();
                        }}
                    >
                        Contact
                    </Link>
                </div>
                <button
                    className={`hamburger ${isOpen ? "open" : ""} ${
                        isOpen ? "active" : ""
                    }`}
                    onClick={toggleMenu}
                >
                    <div className="bar"></div>
                    <div className="bar"></div>
                    <div className="bar"></div>
                </button>
            </div>
        </nav>
    );
};

export default Navbar;
